import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import { PrimaryText, PlanText } from "@components";
import { clubCoursesData } from "@store";
import xIcon from "@assets/image/xIcon.png";
import fbIcon from "@assets/image/facebookIcon.png";
import instaIcon from "@assets/image/instaIcon.png";
import "../../containerStyle.css";

function ProfileView({ props }) {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const facilitiesData = props?.facility;

  const [state, setState] = useState({
    deviceType: "",
  });

  useEffect(() => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|iPod|ipad/i;
    let isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
      setState((prev) => ({ ...prev, deviceType: "Mobile" }));
    } else {
      setState((prev) => ({ ...prev, deviceType: "Desktop" }));
    }
  }, []);

  useEffect(() => {
    dispatch(clubCoursesData(facilitiesData));
  }, [dispatch, facilitiesData]);

  return (
    <Container>
      <BackImg src={`${props?.image?.url}`} />
      <ClubImgView>
        <ClubProfileView>
          <img
            alt="club"
            src={`${props?.logo?.url}`}
            className="w-[100%] h-[100%] rounded-[100%]"
          />
        </ClubProfileView>
      </ClubImgView>
      <div className="w-full h-auto flex flex-col items-center justify-center">
        <PrimaryText className={userNameTxt}>{props?.name}</PrimaryText>
        <div className="w-full h-auto flex felx-row items-center justify-center gap-x-1">
          <PlanText className="text-center opacity-90">
            {props?.address || props?.city}
          </PlanText>
        </div>

        <ContactView>
          <PrimaryText className={contactTxt}>{t("club.contact")}</PrimaryText>
          {state.deviceType === "Mobile" ? (
            <div className={club_view}>
              <PlanText>{"Tel: "} </PlanText>
              <a
                href={`tel:${props?.phone}`}
                target="_blank"
                rel="noreferrer"
                className={club_phone_txt}
              >
                {props?.phone}
              </a>
            </div>
          ) : (
            <PlanText>{"Tel: " + props?.phone} </PlanText>
          )}
          <div className={club_view}>
            <PlanText>{"Email: "} </PlanText>
            <a
              className="font-cambay"
              href={`mailto:${props?.email}?subject=The%20K%20Club&body=Welcome%20The%20K%20Club!`}
              target="_top"
            >
              <p className={club_email_txt}>{props?.email} </p>
            </a>
          </div>
        </ContactView>

        <SovialView>
          <SocialLogo target="_blank" href="https://www.facebook.com/thekclub/">
            <img
              src={fbIcon}
              alt="fb"
              style={{
                width: "20px",
                height: "20px",
              }}
            />
          </SocialLogo>
          <SocialLogo
            target="_blank"
            href="https://www.instagram.com/thekclubireland/"
          >
            <img
              src={instaIcon}
              alt="ins"
              style={{
                width: "20px",
                height: "20px",
              }}
            />
          </SocialLogo>
          <SocialLogo target="_blank" href="https://twitter.com/thekclub">
            <img
              src={xIcon}
              alt="ins"
              style={{
                width: "20px",
                height: "20px",
              }}
            />
          </SocialLogo>
        </SovialView>
      </div>
    </Container>
  );
}

const Container = tw.div`
w-full
h-auto 
rounded-xl
pb-[30px]
`;
const BackImg = tw.img`
w-[100%]
h-[170px] 
rounded-t-xl
`;
const ClubImgView = tw.div`
flex 
flex-row 
w-full 
h-[90px] 
mt-[-50px] 
z-10 
justify-between 
items-center
`;
const ClubProfileView = tw.div`
w-[70px] 
h-[70px] 
ml-[19px] 
flex 
justify-center 
items-center
`;
const userNameTxt = `
text-xl 
font-[Cambay] 
font-semibold 
text-textColor
`;
const ContactView = tw.div`
w-full 
h-auto 
flex 
flex-col 
items-center 
justify-center 
mt-[50px]
`;
const contactTxt = `
text-lg
font-[Cambay] 
font-semibold 
text-textColor
ml-[10px]
`;
const SovialView = tw.div`
w-full 
h-auto 
flex 
flex-row 
items-center 
justify-center 
mt-[50px] 
gap-x-4
`;
const SocialLogo = tw.a`
duration-500 
hover:transform 
hover:scale-125
`;

const club_view = `
w-fit 
h-auto 
flex flex-row 
items-center justify-center 
gap-x-[5px] 
opacity-90
`;

const club_phone_txt = `
text-white255 
text-sm 
text-center 
font-[Cambay] 
txt-underline-animation hover:text-[#9590ff] 
hover:cursor-pointer
`;
const club_email_txt = `
text-textColor 
text-sm 
font-[Cambay] 
txt-underline-animation hover:text-[#b8b5ff] 
hover:cursor-pointer
`;

export default ProfileView;
